import React from "react";
import { forwardRefAs, Generic } from "../../base";
export const SelectOption = forwardRefAs((props, ref) => React.createElement(Generic, Object.assign({ ref: ref }, props)), { as: "option" });
SelectOption.displayName = "Select.Option";
//# sourceMappingURL=select-option.js.map